<template>
  <div class="chart">
    <h4>{{ title }} ({{ unit }})</h4>
    <p v-if="!points.length">{{ $t('暂无运动记录') }}</p>
    <template v-else>
      <svg viewBox="0 0 340 180" role="img" :aria-label="title">
        <text x="2" y="16" font-size="11">{{ maximum }}</text>
        <text x="16" y="153" font-size="11">0</text>
        <line x1="38" y1="150" x2="332" y2="150" stroke="#aaa" />
        <line x1="38" y1="20" x2="38" y2="150" stroke="#aaa" />
        <rect v-for="point in points" :key="point.reportTime" :x="x(point.reportTime) - barWidth / 2"
          :y="150 - point.value / maximum * 125" :width="barWidth" :height="Math.max(1, point.value / maximum * 125)"
          fill="#1989fa" @click="selected = point">
          <title>{{ time(point.reportTime) }}: {{ point.value }} {{ unit }}</title>
        </rect>
        <text x="38" y="172" font-size="11">{{ time(points[0].reportTime) }}</text>
        <text x="332" y="172" text-anchor="end" font-size="11">{{ time(points[points.length - 1].reportTime) }}</text>
      </svg>
      <p v-if="selected" role="status">{{ time(selected.reportTime) }} · {{ selected.value }} {{ unit }}</p>
      <details><summary>{{ $t('查看明细') }} ({{ points.length }})</summary>
        <div class="details"><table><thead><tr><th>{{ $t('上报时间') }}</th><th>{{ title }} ({{ unit }})</th></tr></thead>
          <tbody><tr v-for="point in points" :key="point.reportTime"><td>{{ time(point.reportTime) }}</td><td>{{ point.value }}</td></tr></tbody>
        </table></div>
      </details>
    </template>
  </div>
</template>
<script>
export default {
  props: {records: {type: Array, default: () => []}, field: String, title: String, unit: String},
  data() { return {selected: null} },
  computed: {
    points() { return this.records.filter(row => row[this.field] != null).map(row => ({reportTime: row.reportTime, value: row[this.field]})) },
    maximum() { return Math.max(1, ...this.points.map(point => point.value)) },
    barWidth() { return Math.max(1, Math.min(12, 250 / Math.max(1, this.points.length))) }
  },
  watch: {records() { this.selected = null }},
  methods: {
    x(time) {
      const first = this.points[0].reportTime, last = this.points[this.points.length - 1].reportTime
      return last === first ? 185 : 45 + (time - first) / (last - first) * 280
    },
    time(value) { return new Date(value + 8 * 3600000).toISOString().slice(11, 19) }
  }
}
</script>
<style scoped>
.chart { margin: 0 16px 16px; padding: 12px 0 16px; border-top: 1px solid #ebedf0; font-size: 14px; line-height: 1.5; }
h4 { margin: 0 0 12px; font-size: 16px; font-weight: 600; color: #323233; }
p { margin: 0; padding: 32px 0; font-size: 14px; text-align: center; color: #969799; }
p[role="status"] { padding: 8px 0; color: #323233; }
svg { display: block; width: 100%; height: auto; }
.details { max-height: 240px; overflow: auto; }
table { width: 100%; font-size: 13px; text-align: left; border-collapse: collapse; }
td, th { padding: 6px; border-bottom: 1px solid #eee; }
summary { padding-top: 8px; cursor: pointer; color: #1989fa; font-size: 13px; }
</style>
